import { render, staticRenderFns } from "./MainDisease.vue?vue&type=template&id=1252a8f8&scoped=true&"
import script from "./MainDisease.vue?vue&type=script&lang=js&"
export * from "./MainDisease.vue?vue&type=script&lang=js&"
import style0 from "./MainDisease.vue?vue&type=style&index=0&id=1252a8f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1252a8f8",
  null
  
)

export default component.exports